import * as React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { SnackbarProvider } from './providers/SnackBarProvider';
import { AuthProvider } from './providers/AuthProvider';
import { AccessProvider } from './providers/AccessProvider';
import { FirebaseAppProvider } from './providers/FirebaseAppProvider';
import { RemoteConfigProvider } from './providers/RemoteConfigProvider';
import { SignedInCheck } from './components/Account/SignedInCheck';
import { SinglePattern } from './components/SinglePattern';
import PatternResultPage from './components/PatternPurchase/PatternResultPage';
import Main from './components/Main/Index';
import { LandingPage } from './components/LandingPage/LandingPage';
import { PatternLibrary } from './components/PatternLibrary/PatternLibrary';
import { MyPatternsPage } from './components/MyPatterns/MyPatternsPage';
import { ErrorBoundary } from './components/ErrorBoundary';
import { ROUTES } from './config/constants';

const App = () => {
	return (
		<ErrorBoundary>
			<FirebaseAppProvider>
				<RemoteConfigProvider>
					<AuthProvider>
						<AccessProvider>
							<SnackbarProvider>
								<BrowserRouter>
									<Routes>
										<Route
											path="/"
											element={
												<SignedInCheck
													LandingPage={LandingPage}
													Main={Main}
												/>
											}
										/>
										<Route
											path="*"
											element={
												<SignedInCheck
													LandingPage={LandingPage}
													Main={Main}
												/>
											}
										/>
										<Route
											path={ROUTES.ABOUT}
											element={<LandingPage />}
										/>
										<Route
											path={ROUTES.PATTERN_MAKER}
											element={<Main />}
										/>
										<Route
											path={ROUTES.SINGLE_PATTERN}
											element={<SinglePattern />}
										/>
										<Route
											path={ROUTES.PATTERN_RESULT}
											element={<PatternResultPage />}
										/>
										<Route
											path={ROUTES.PATTERN_LIBRARY}
											element={<PatternLibrary />}
										/>
										<Route
											path={ROUTES.MY_PATTERNS}
											element={<MyPatternsPage />}
										/>
									</Routes>
								</BrowserRouter>
							</SnackbarProvider>
						</AccessProvider>
					</AuthProvider>
				</RemoteConfigProvider>
			</FirebaseAppProvider>
		</ErrorBoundary>
	);
};

export default App;
